/* 🤖 this file was generated by script */
export const wiconLinkOff = {
  name: 'link_off',
  data: `<svg viewBox="0 0 20 21"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12.5 6.5H14a4 4 0 014 4c0 .98-.1 1.9-.73 2.7M7.5 14.5H6a4 4 0 01-4-4c0-2.05 1.13-4 3.43-4m1.57 4h3m0 0l-4.57-4m4.57 4l4.57 4m-1.32-4h.25M2 3.5l3.43 3m9.14 8l3.43 3m-3.43-3H12.5"/></svg>`,
};
